module.exports = __webpack_public_path__ + "static/media/balance_col_img.7b6818f9.svg";